namespace GeniuzPOS.Lookups {
    export interface VwSkuLookupPurchaseRow {
        SkuCode?: string;
        SkuDesc?: string;
        FullName?: string;
        ConsignFg?: number;
        ConsignGp?: number;
        LastPurPrice?: number;
        PurUnit?: string;
        PurUnitPrice?: number;
        PurUnitRatio?: number;
        StkUnit?: string;
        MinOrderQty?: number;
        MaxOrderQty?: number;
        SupplierId?: string;
    }

    export namespace VwSkuLookupPurchaseRow {
        export const idProperty = 'SkuCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwSkuLookupPurchase';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            FullName = "FullName",
            ConsignFg = "ConsignFg",
            ConsignGp = "ConsignGp",
            LastPurPrice = "LastPurPrice",
            PurUnit = "PurUnit",
            PurUnitPrice = "PurUnitPrice",
            PurUnitRatio = "PurUnitRatio",
            StkUnit = "StkUnit",
            MinOrderQty = "MinOrderQty",
            MaxOrderQty = "MaxOrderQty",
            SupplierId = "SupplierId"
        }
    }
}
